import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/gcstudent/myprofilepage/MyProfilePage.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";

const isOn = (val) => val === 1 || val === "1" || val === true;

const MyProfilePage = () => {
  // ... baaki poora code same rahega
  const [activeTab, setActiveTab] = useState("personal");
  const { baseUrl, loggedInUser, setLoggedInUser, authToken } = useContext(AppContext);

const updateProfile = () => {

    const formData = new FormData();

    formData.append("student_id", personalInfo.id);
    formData.append("fullName", personalInfo.fullName);
    formData.append("phone", personalInfo.phone);

    axios.post(
        `${baseUrl}/student/updateProfile`,
        formData,
       { headers: {  "Authorization": `Bearer ${authToken}` } }
    )
    .then((res)=>{

        if(res.data.success){

            // ✅ Ab localStorage ki jagah Context update ho raha hai
            setLoggedInUser(res.data.student);

            Swal.fire({
                icon:"success",
                title:"Success",
                text:"Profile Updated Successfully"
            });

        }

    })
    .catch((err)=>{

        console.log(err.response);

        Swal.fire({
            icon:"error",
            title:"Error",
            text:"Something went wrong"
        });

    });

};
const UpdatePassword = () => {

  if (!passwords.current) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Please enter current password",
    });
    return;
  }

  if (!passwords.newPass) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Please enter new password",
    });
    return;
  }

  if (passwords.newPass !== passwords.repeat) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Passwords do not match",
    });
    return;
  }

  const formData = new FormData();
  formData.append("lbstudent_id", personalInfo.id);
  formData.append("current_password", passwords.current);
  formData.append("new_password", passwords.newPass);

  axios.post(
    `${baseUrl}/student/password/changePassword`,
    formData,
    { headers: {  "Authorization": `Bearer ${authToken}` } }
  )
  .then((res) => {

    console.log("Password Response => ", res.data);

    if (res.data.success) {

      // ✅ Ab localStorage ki jagah Context update ho raha hai
      setLoggedInUser(res.data.student);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Password Updated Successfully",
      });

      setPasswords({
        current: "",
        newPass: "",
        repeat: "",
      });

    } else {

      Swal.fire({
        icon: "error",
        title: "Error",
        text: res.data.message,
      });

    }

  })
  .catch((err) => {

    console.log("Password Error => ", err.response);

    Swal.fire({
      icon: "error",
      title: "Error",
      text:
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Something went wrong",
    });

  });

};

  const [personalInfo, setPersonalInfo] = useState({
    id: "",
    fullName: "",
    email: "",
    phone: "",
    department: "",
    studentId: "",
});

  const [passwords, setPasswords] = useState({
    current: "",
    newPass: "",
    repeat: "",
  });

  const [notifications, setNotifications] = useState({
  email: false,
  inApp: false,
});
const UpdateNotificationSettings = (emailStatus, inAppStatus) => {

  const formData = new FormData();

  formData.append("lbstudent_id", personalInfo.id);
  formData.append("email_notifications", emailStatus ? 1 : 0);
  formData.append("inapp_notifications", inAppStatus ? 1 : 0);

  axios.post(
    `${baseUrl}/student/notifications/updateNotifications`,
    formData,
    { headers: {  "Authorization": `Bearer ${authToken}` } }
  )
  .then((res) => {

    if (res.data.success) {
       // ✅ Ab localStorage ki jagah Context update ho raha hai
       setLoggedInUser(res.data.student);

  Swal.fire({
    icon: "success",
    title: "Success",
    text: "Notification settings updated",
    timer: 1200,
    showConfirmButton: false,
  });

}
      
    

  })
  .catch((err) => {
    console.log(err);
  });

};
  

useEffect(() => {
  if (loggedInUser) {
    setPersonalInfo({
      id: loggedInUser.id || "",
      fullName: loggedInUser.fullName || "",
      email: loggedInUser.email || "",
      phone: loggedInUser.phone || "",
      department: loggedInUser.program || "",
      studentId: loggedInUser.roll_no || "",
    });

    setNotifications({
      email: isOn(loggedInUser.emailNotifications),
      inApp: isOn(loggedInUser.inappNotifications),
    });
  }
}, [loggedInUser]);


  const TabChange = (tab) => {
    setActiveTab(tab);
  };

  const PersonalChange = (e) => {
    setPersonalInfo({ ...personalInfo, [e.target.name]: e.target.value });
  };

  const PasswordChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  

  return (
    <Container fluid className="gcstudent-profile-wrapper">
      <Row>
        <Col xs={12}>
          <h2 className="gcstudent-profile-title">My Profile</h2>

          {/* Tab Buttons */}
          <div className="gcstudent-tab-bar">
            <button
              className={`gcstudent-tab-btn ${activeTab === "personal" ? "gcstudent-tab-active" : ""}`}
              onClick={() => TabChange("personal")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" className="gcstudent-tab-icon">
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
              </svg>
              Personal Info
            </button>
            <button
              className={`gcstudent-tab-btn ${activeTab === "security" ? "gcstudent-tab-active" : ""}`}
              onClick={() => TabChange("security")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" className="gcstudent-tab-icon">
                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
              </svg>
              Security
            </button>
            <button
              className={`gcstudent-tab-btn ${activeTab === "notifications" ? "gcstudent-tab-active" : ""}`}
              onClick={() => TabChange("notifications")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" className="gcstudent-tab-icon">
                <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>
              </svg>
              Notifications
            </button>
          </div>

          {/* Tab Content */}
          <div className="gcstudent-tab-content-area">

            {/* Personal Info Tab */}
            {activeTab === "personal" && (
              <div className="gcstudent-card gcstudent-anim-in">
                {/* Profile Header */}
                <div className="gcstudent-profile-header">
                  <div className="gcstudent-avatar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                    </svg>
                  </div>
                  <div className="gcstudent-profile-meta">
                    <h5 className="gcstudent-profile-name">{personalInfo.fullName}</h5>
                    <span className="gcstudent-profile-role">Student • {personalInfo.department}</span>
                  </div>
                </div>

                {/* Form Fields */}
                <div className="gcstudent-form-group">
                  <label className="gcstudent-label">Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    className="gcstudent-input"
                    value={personalInfo.fullName}
                    onChange={PersonalChange}
                  />
                </div>
                <div className="gcstudent-form-group">
                  <label className="gcstudent-label">Email Address</label>
                  <input
                      type="email"
                       name="email"
                      className="gcstudent-input"
                      value={personalInfo.email}
                            disabled
                   />
                   </div>
                <div className="gcstudent-form-group">
                  <label className="gcstudent-label">Phone Number</label>
                  <input
                    type="text"
                    name="phone"
                    className="gcstudent-input"
                    value={personalInfo.phone}
                    onChange={PersonalChange}
                  />
                </div>
                <div className="gcstudent-form-group">
                  <label className="gcstudent-label">Department</label>
                  <input
                       type="text"
                      name="department"
                       className="gcstudent-input"
                      value={personalInfo.department}
                     disabled
                   />
                </div>
                <div className="gcstudent-form-group">
                  <label className="gcstudent-label">Student ID</label>
                  <input
                     type="text"
                       name="studentId"
                        className="gcstudent-input"
                           value={personalInfo.studentId}
                            disabled
                            />
                </div>
                 <button className="gcstudent-btn-primary" onClick={updateProfile}>
               
               Update Profile
              </button>
                
              </div>
            )}
            
            {/* Security Tab */}
            {activeTab === "security" && (
              <div className="gcstudent-card gcstudent-anim-in">
                <div className="gcstudent-section-heading">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16" className="gcstudent-section-icon">
                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                  </svg>
                  <h5>Change Password</h5>
                </div>

                <div className="gcstudent-form-group">
                  <label className="gcstudent-label">Current Password</label>
                  <input
                    type="password"
                    name="current"
                    className="gcstudent-input"
                    placeholder="Enter current password"
                    value={passwords.current}
                    onChange={PasswordChange}
                  />
                </div>
                <div className="gcstudent-form-group">
                  <label className="gcstudent-label">New Password</label>
                  <input
                    type="password"
                    name="newPass"
                    className="gcstudent-input"
                    placeholder="Enter new password"
                    value={passwords.newPass}
                    onChange={PasswordChange}
                  />
                </div>
                <div className="gcstudent-form-group">
                  <label className="gcstudent-label">Repeat New Password</label>
                  <input
                    type="password"
                    name="repeat"
                    className="gcstudent-input"
                    placeholder="Repeat new password"
                    value={passwords.repeat}
                    onChange={PasswordChange}
                  />
                </div>
                 {/* Update Password button */}
<button
  className="gcstudent-btn-primary"
  onClick={UpdatePassword}
>
  Update Password
</button>
                
              </div>
            )}

            {/* Notifications Tab */}
            {activeTab === "notifications" && (
              <div className="gcstudent-card gcstudent-anim-in">
                <div className="gcstudent-section-heading">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16" className="gcstudent-section-icon">
                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>
                  </svg>
                  <h5>Notification Settings</h5>
                </div>

                <div className="gcstudent-notif-item">
                  <div className="gcstudent-notif-text">
                    <span className="gcstudent-notif-title">Email Notifications</span>
                    <span className="gcstudent-notif-desc">Receive notifications via email for book returns, reservations, and updates.</span>
                  </div>
                  <div
                    className={`gcstudent-toggle ${notifications.email ? "gcstudent-toggle-on" : ""}`}
                    onClick={() => {

  const newEmailStatus = !notifications.email;

  setNotifications({
    ...notifications,
    email: newEmailStatus,
  });

  UpdateNotificationSettings(
    newEmailStatus,
    notifications.inApp
  );

}}
                  >
                    <div className="gcstudent-toggle-knob"></div>
                  </div>
                </div>

                <div className="gcstudent-notif-item">
                  <div className="gcstudent-notif-text">
                    <span className="gcstudent-notif-title">In-App Notifications</span>
                    <span className="gcstudent-notif-desc">Receive in-app notifications for alerts, due dates, and system updates.</span>
                  </div>
                  <div
                    className={`gcstudent-toggle ${notifications.inApp ? "gcstudent-toggle-on" : ""}`}
                    onClick={() => {

  const newInAppStatus = !notifications.inApp;

  setNotifications({
    ...notifications,
    inApp: newInAppStatus,
  });

  UpdateNotificationSettings(
    notifications.email,
    newInAppStatus
  );

}}
                  >
                    <div className="gcstudent-toggle-knob"></div>
                  </div>
                </div>
              </div>
            )}

          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MyProfilePage;